import momentTimezone from 'moment-timezone';

export const formatDateTimeColumn = (col, timezone) => !col ? 'D/N' : 
        momentTimezone(col).tz(timezone).format('DD/MM/YYYY [-] HH:mm:ss');